export const REGISTRY_URL =
	"https://raw.githubusercontent.com/elizaos-plugins/registry/refs/heads/main/index.json";
